export const PERMS = {
    READ: 'trailer_types.read',
    UPDATE: 'trailer_types.update',
    DELETE: 'trailer_types.delete',
    CREATE: 'trailer_types.create',
    EXPORT: 'trailer_types.export',
}
